

// export default function ExamPatternRenderer({
//   examPatterns = [],
//   onExamChange,
//   onExamRowChange,
// }) {
//   const patterns = Array.isArray(examPatterns) ? examPatterns : [examPatterns];

//   return (
//     <Stack spacing={3}>
//       {patterns.map((section, examIndex) => {
//         const exam = section?.fields || {};
//         const rows = Array.isArray(exam.rows) ? exam.rows : [];

//         return (
//           <Paper key={examIndex} sx={{ p: 3 }}>
//             <Typography variant="h6" gutterBottom>
//               Exam Pattern {examIndex + 1}
//             </Typography>

//             <Stack spacing={2}>
//               <TextField
//                 label="Title"
//                 value={section?.title || ""}
//                 onChange={(e) =>
//                   onExamChange(examIndex, "title", e.target.value)
//                 }
//                 fullWidth
//               />

//               <TextField
//                 label="Total Questions"
//                 value={exam.total_questions || ""}
//                 onChange={(e) =>
//                   onExamChange(
//                     examIndex,
//                     "total_questions",
//                     e.target.value
//                   )
//                 }
//                 fullWidth
//               />

//               <TextField
//                 label="Total Marks"
//                 value={exam.total_marks || ""}
//                 onChange={(e) =>
//                   onExamChange(examIndex, "total_marks", e.target.value)
//                 }
//                 fullWidth
//               />

//               <TextField
//                 label="Duration"
//                 value={exam.duration || ""}
//                 onChange={(e) =>
//                   onExamChange(examIndex, "duration", e.target.value)
//                 }
//                 fullWidth
//               />

//               <Box sx={{ overflowX: "auto" }}>
//                 <Table size="small">
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>Subject</TableCell>
//                       <TableCell>Questions</TableCell>
//                       <TableCell>Marks</TableCell>
//                       <TableCell>Duration</TableCell>
//                     </TableRow>
//                   </TableHead>

//                   <TableBody>
//                     {rows.map((row, rowIndex) => (
//                       <TableRow key={rowIndex}>
//                         <TableCell>
//                           <TextField
//                             value={row.subject || ""}
//                             onChange={(e) =>
//                               onExamRowChange(
//                                 examIndex,
//                                 rowIndex,
//                                 "subject",
//                                 e.target.value
//                               )
//                             }
//                             fullWidth
//                             size="small"
//                           />
//                         </TableCell>

//                         <TableCell>
//                           <TextField
//                             value={row.questions || ""}
//                             onChange={(e) =>
//                               onExamRowChange(
//                                 examIndex,
//                                 rowIndex,
//                                 "questions",
//                                 e.target.value
//                               )
//                             }
//                             fullWidth
//                             size="small"
//                           />
//                         </TableCell>

//                         <TableCell>
//                           <TextField
//                             value={row.marks || ""}
//                             onChange={(e) =>
//                               onExamRowChange(
//                                 examIndex,
//                                 rowIndex,
//                                 "marks",
//                                 e.target.value
//                               )
//                             }
//                             fullWidth
//                             size="small"
//                           />
//                         </TableCell>

//                         <TableCell>
//                           <TextField
//                             value={row.duration || ""}
//                             onChange={(e) =>
//                               onExamRowChange(
//                                 examIndex,
//                                 rowIndex,
//                                 "duration",
//                                 e.target.value
//                               )
//                             }
//                             fullWidth
//                             size="small"
//                           />
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </Box>
//             </Stack>
//           </Paper>
//         );
//       })}
//     </Stack>
//   );
// }
import "./renderer.css";
export default function ExamPatternRenderer({ section }) {
    const examPatterns = Array.isArray(section) ? section : [section];

    return (
        <div className="exam-pattern-wrapper">
            {examPatterns.map((item, index) => {
                const exam = item?.fields || {};
                const rows = Array.isArray(exam.rows) ? exam.rows : [];

                return (
                    <div className="exam-pattern" key={index}>
                        <h4>{item?.title || "Exam Pattern"}</h4>

                        <table className="table">
                            <tbody>
                                <tr>
                                    <td><b>Total Questions</b></td>
                                    <td>{exam.total_questions || "-"}</td>
                                </tr>
                                <tr>
                                    <td><b>Total Marks</b></td>
                                    <td>{exam.total_marks || "-"}</td>
                                </tr>
                                <tr>
                                    <td><b>Duration</b></td>
                                    <td>{exam.duration || "-"}</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="inner-table">
                            <thead>
                                <tr>
                                    <th>Subject</th>
                                    <th>Questions</th>
                                    <th>Marks</th>
                                    <th>Duration</th>
                                </tr>
                            </thead>

                            <tbody>
                                {rows.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        <td>{row.subject || "-"}</td>
                                        <td>{row.questions || "-"}</td>
                                        <td>{row.marks || "-"}</td>
                                        <td>{row.duration || "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                );
            })}
        </div>
    );
}